/* eslint-disable class-methods-use-this */
import React from 'react';
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';
import { forms } from 'style/config';
import {
    Box, Divider, Link, Text
} from 'components/ui';
import Radio from 'components/Inputs/Radio/Radio';
import PaymentDisplay from 'components/RwdCheckout/Sections/Payment/Display';
import agentAwareUtils from 'utils/AgentAware';
import { mediaQueries, colors } from 'style/config';
import checkoutUtils from 'utils/Checkout';
import PayPalCheckout from 'utils/PayPalCheckout';
import localeUtils from 'utils/LanguageLocale';

import DefaultPaymentCheckbox from 'components/RwdCheckout/Sections/Payment/Section/DefaultPaymentCheckbox';
import { PAYPAL_LEGAL_LINKS, PAY_PAL } from 'constants/PayPal';

const getPayPalLegalLinks = () => {
    if (localeUtils.isCanada() && localeUtils.isFrench()) {
        return {
            terms: PAYPAL_LEGAL_LINKS.terms.caFr,
            privacy: PAYPAL_LEGAL_LINKS.privacy.caFr
        };
    } else if (localeUtils.isCanada()) {
        return {
            terms: PAYPAL_LEGAL_LINKS.terms.caEn,
            privacy: PAYPAL_LEGAL_LINKS.privacy.caEn
        };
    } else {
        return {
            terms: PAYPAL_LEGAL_LINKS.terms.us,
            privacy: PAYPAL_LEGAL_LINKS.privacy.us
        };
    }
};

class PaypalRadio extends BaseClass {
    handlePayWithPayPalEditOnClick = () => {
        const { handlePayWithPayPalOnClick } = this.props;
        handlePayWithPayPalOnClick(true);
    };
    render() {
        const {
            isPayWithPayPal,
            paypalOption,
            handlePayWithPayPalOnClick,
            hasAutoReplenishItemInBasket,
            isZeroCheckout,
            isPayPalPayLaterEligible,
            fieldsetName,
            editPaypal,
            paypalLegalNoticePrefix,
            paypalLegalNoticeAnd,
            paypalLegalNoticeTerms,
            paypalLegalNoticePrivacy
        } = this.props;

        const isGuestCheckout = checkoutUtils.isGuestOrder();
        const shouldShowDefaultPaymentCheckbox = isPayWithPayPal && !isGuestCheckout && PayPalCheckout.isSetPayPalAsDefaultPaymentEnabled();
        const shouldShowPayPalLegalNotice = isPayWithPayPal;
        const { terms: termsUrl, privacy: privacyUrl } = getPayPalLegalLinks();

        return (
            <React.Fragment>
                <div
                    className={agentAwareUtils.applyHideAgentAwareClass()}
                    ref={'paypal'}
                    css={styles.paypalContainer}
                >
                    <Radio
                        data-at={Sephora.debug.dataAt('paypal_radio')}
                        dotOffset={0}
                        paddingY={3}
                        alignItems='center'
                        name={fieldsetName || 'payWithPayPal'}
                        checked={isPayWithPayPal}
                        disabled={hasAutoReplenishItemInBasket || isZeroCheckout}
                        onClick={handlePayWithPayPalOnClick}
                    >
                        <PaymentDisplay
                            isPayPal={true}
                            checkoutEnabled={!hasAutoReplenishItemInBasket}
                            paypalEmail={paypalOption && paypalOption.email}
                            isPayPalPayLaterEligible={isPayPalPayLaterEligible}
                        />
                    </Radio>
                    {paypalOption && (
                        <Box
                            marginLeft={forms.RADIO_SIZE + forms.RADIO_MARGIN + 'px'}
                            marginBottom={[3, null]}
                        >
                            <Link
                                padding={2}
                                margin={-2}
                                color='blue'
                                onClick={this.handlePayWithPayPalEditOnClick}
                            >
                                {editPaypal}
                            </Link>
                        </Box>
                    )}
                </div>
                {(shouldShowDefaultPaymentCheckbox || shouldShowPayPalLegalNotice) && (
                    <Box
                        marginLeft={forms.RADIO_SIZE + forms.RADIO_MARGIN + 'px'}
                        marginBottom={[3, null]}
                        marginTop={[-1, null]}
                        maxWidth='340px'
                    >
                        {shouldShowDefaultPaymentCheckbox && <DefaultPaymentCheckbox paymentName={PAY_PAL} />}
                        {shouldShowPayPalLegalNotice && (
                            <Text
                                is='p'
                                fontSize='sm'
                                lineHeight='tight'
                                marginTop={0}
                            >
                                {paypalLegalNoticePrefix}{' '}
                                <Link
                                    href={termsUrl}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    css={{ textDecoration: 'underline', color: colors.blue }}
                                >
                                    {paypalLegalNoticeTerms}
                                </Link>{' '}
                                {paypalLegalNoticeAnd}{' '}
                                <Link
                                    href={privacyUrl}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    css={{ textDecoration: 'underline', color: colors.blue }}
                                >
                                    {paypalLegalNoticePrivacy}
                                </Link>
                                .
                            </Text>
                        )}
                    </Box>
                )}
                <Divider marginBottom={[0, 3]} />
            </React.Fragment>
        );
    }
}

const styles = {
    paypalContainer: {
        [mediaQueries.md]: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    }
};

export default wrapComponent(PaypalRadio, 'PaypalRadio', true);
